import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Play, Star, Check, ChevronDown, Monitor, Zap, Users, Trophy, ArrowRight } from 'lucide-react';
import Navbar from './Navbar';
import Hero from './Hero';
import Features from './Features';
import Benefits from './Benefits';
import Demo from './Demo';
import Testimonials from './Testimonials';
import Pricing from './Pricing';
import FAQ from './FAQ';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <Navbar />
      <Hero />
      <Features />
      <Benefits />
      {/* <Demo /> */}
      {/* <Testimonials /> */}
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
};

export default LandingPage;